import React from 'react';
import { Button } from 'antd';
import classnames from 'classnames';

import './styles.scss';

const MyButtonV2 = ({ className, children, ...rest }) => {
  return (
    <Button className={classnames('site-button-2', className)} {...rest}>
      {children}
    </Button>
  );
};

MyButtonV2.propTypes = {};

export default MyButtonV2;
